import { getGetUserActivityStatsMockHandler } from "@vega-api/generated/analytics-user-activity/analytics-user-activity.msw";

const DAY_MS = 24 * 60 * 60 * 1000;
const DEMO_WINDOW_DAYS = 6 * 30;

const buildDemoLoginDays = () => {
  const now = new Date();
  const todayStart = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
  );

  return Array.from({ length: DEMO_WINDOW_DAYS }, (_, index) => {
    const timestamp = todayStart - (DEMO_WINDOW_DAYS - 1 - index) * DAY_MS;
    const weekday = new Date(timestamp).getUTCDay();
    const isWeekend = weekday === 0 || weekday === 6;
    const dayNumber = Math.floor(timestamp / DAY_MS);

    return !isWeekend && dayNumber % 9 !== 3
      ? new Date(timestamp).toISOString().slice(0, 10)
      : undefined;
  }).filter((day): day is string => day !== undefined);
};

export const getUserActivityStatsDemoHandler = () =>
  getGetUserActivityStatsMockHandler({
    data: {
      activeDays: 132,
      currentStreakDays: 4,
      longestStreakDays: 11,
      memberSince: "2024-03",
      subdocTasksTouched: 27,
      subscriptionsTouched: 9,
      loginDays: buildDemoLoginDays(),
    },
    meta: { page: 1, totalPages: 1, sorting: [] },
    errors: null,
  });
